import React from 'react';
import queryString from 'query-string';
import { withRouter } from 'react-router-dom';
import UnsubscribeSuccess from '../Components/UnsubscribeSuccess/UnsubscribeSuccess';
import * as PersonActions from '../Actions/PersonActivityAction';

class UnsubscribeSuccessContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showErrorPage: false,
    };
    this.updateStatus = this.updateStatus.bind(this);
  }

  componentDidMount() {
    const { location } = this.props;
    const { ref } = queryString.parse(location.search);
    if (!ref) {
      this.setState({
        showErrorPage: true,
      });
    } else {
      this.setState({
        ref,
      });
    }
  }

  updateStatus(IsAllConversations) {
    const { history } = this.props;
    const { ref } = this.state;
    PersonActions.updateSubscriptionStatus(ref, IsAllConversations, 'Subscribed', history, 'SubscribeSuccess');
  }

  render() {
    const { showErrorPage } = this.state;
    if (showErrorPage) {
      return <div>Invalid URL</div>;
    }
    return <UnsubscribeSuccess updateStatus={this.updateStatus} />;
  }
}

export default withRouter(UnsubscribeSuccessContainer);
